import { useGuest } from '@/contexts/GuestContext';
import { useNavigate } from 'react-router-dom';
import { Sparkles, X } from 'lucide-react';
import QuickOTPModal from './QuickOTPModal';
import { useAuth } from '@/App';

function GuestBanner() {
  const { showBanner, dismissBanner, setShowSignup } = useGuest();

  // Don't show on landing page — it has its own CTAs
  const isLandingPage = window.location.pathname === '/';
  if (!showBanner || isLandingPage) return null;

  return (
    <div className="fixed top-16 left-0 right-0 z-[9990] px-3 animate-slide-down" data-testid="guest-banner">
      <div className="bg-gradient-to-r from-[#2F80ED] to-[#7B61FF] rounded-xl p-3 shadow-lg shadow-blue-500/20 flex items-center gap-3">
        <Sparkles className="h-5 w-5 text-white shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-white text-sm font-semibold">Sign up to unlock all features</p>
          <p className="text-white/70 text-xs">Free account, takes 30 seconds</p>
        </div>
        <button
          onClick={() => { dismissBanner(); setShowSignup(true); }}
          className="bg-white text-[#2F80ED] text-xs font-bold px-3 py-1.5 rounded-lg shrink-0"
          data-testid="banner-signup-btn"
        >
          Sign Up
        </button>
        <button onClick={dismissBanner} className="text-white/60 hover:text-white shrink-0">
          <X className="h-4 w-4" />
        </button>
      </div>
      <style>{`
        @keyframes slide-down { from { transform: translateY(-100%); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
        .animate-slide-down { animation: slide-down 0.3s ease-out; }
      `}</style>
    </div>
  );
}

function GuestPopup() {
  const { showSignup, forceSignup, stage, handleMaybeLater, dismissSignup } = useGuest();
  const { user } = useAuth();

  // Don't show if logged in or on landing page
  const isLandingPage = window.location.pathname === '/';
  if (user || !showSignup || isLandingPage) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-end sm:items-center justify-center" data-testid="guest-signup-modal">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={forceSignup ? undefined : dismissSignup} />
      <div className="relative w-full max-w-md mx-4 mb-4 sm:mb-0">
        <QuickOTPModal
          onSuccess={() => {
            dismissSignup();
          }}
          onClose={forceSignup ? () => {} : dismissSignup}
          dismissable={!forceSignup}
        />
      </div>
    </div>
  );
}

export default function GuestSignupModal() {
  return (
    <>
      <GuestBanner />
      <GuestPopup />
    </>
  );
}
